import React, { useRef, useEffect } from "react";

const Widget = ({ scriptHTML, scriptSRC, containerId, type }) => {
  const ref = useRef();

  let tvScriptLoadingPromise;

  useEffect(() => {
    let refValue;

    if (ref.current) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.setAttribute("data-nscript", "afterInteractive");
        script.src = scriptSRC;
        script.id = "291382913";
        script.async = true;
        script.type = "text/javascript";
        script.onload = resolve;

        script.innerHTML = JSON.stringify(scriptHTML);

        ref.current.appendChild(script);
        refValue = ref.current;
      });
      tvScriptLoadingPromise.then(() => ref.current && ref.current());
    }
    return () => {
      ref.current = null;
    };
  }, [ref, scriptHTML, type, scriptSRC]);

  return <div ref={ref} id={containerId} />;
};

export default Widget;
